import { render, staticRenderFns } from "./LegendComponent.vue?vue&type=template&id=ad2e7f2a&scoped=true"
import script from "./LegendComponent.vue?vue&type=script&lang=js"
export * from "./LegendComponent.vue?vue&type=script&lang=js"
import style0 from "./LegendComponent.vue?vue&type=style&index=0&id=ad2e7f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2e7f2a",
  null
  
)

export default component.exports